import { render, staticRenderFns } from "./member-extend.vue?vue&type=template&id=e808b65a&scoped=true&"
import script from "./member-extend.vue?vue&type=script&lang=js&"
export * from "./member-extend.vue?vue&type=script&lang=js&"
import style0 from "./member-extend.vue?vue&type=style&index=0&id=e808b65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e808b65a",
  null
  
)

component.options.__file = "member-extend.vue"
export default component.exports